/**
 * Currency Converter - Display Only
 * Sadece görünümde döviz çevirisi yapar, checkout etkilenmez
 */

(function() {
  'use strict';

  const COOKIE_NAME = 'vienetta_currency';
  const COOKIE_DAYS = 30;

  // State
  let currentCurrency = null;
  let currencies = [];
  let isOpen = false;

  // DOM Elements
  let converter, trigger, dropdown, currentDisplay, currentSymbol;

  /**
   * Cookie işlemleri
   */
  const Cookie = {
    set(name, value, days) {
      const expires = new Date();
      expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
      document.cookie = `${name}=${encodeURIComponent(JSON.stringify(value))};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
    },

    get(name) {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      if (match) {
        try {
          return JSON.parse(decodeURIComponent(match[2]));
        } catch (e) {
          return null;
        }
      }
      return null;
    },

    remove(name) {
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
    }
  };

  /**
   * Para birimi listesini DOM'dan oku
   */
  function loadCurrencies() {
    const options = document.querySelectorAll('.currency-converter__option');
    currencies = [];

    options.forEach(option => {
      currencies.push({
        code: option.dataset.currencyCode,
        symbol: option.dataset.currencySymbol,
        rate: parseFloat(option.dataset.currencyRate) || 1,
        position: option.dataset.currencyPosition || 'before',
        element: option
      });
    });

    return currencies;
  }

  /**
   * Kayıtlı para birimini yükle veya varsayılanı kullan
   */
  function loadSavedCurrency() {
    const saved = Cookie.get(COOKIE_NAME);

    if (saved && saved.code) {
      const found = currencies.find(c => c.code === saved.code);
      if (found) {
        return found;
      }
    }

    // Varsayılan (ilk seçenek)
    return currencies[0] || null;
  }

  /**
   * Dropdown aç/kapat
   */
  function toggleDropdown(open) {
    isOpen = typeof open === 'boolean' ? open : !isOpen;

    converter.setAttribute('data-open', isOpen);
    trigger.setAttribute('aria-expanded', isOpen);
    dropdown.setAttribute('aria-hidden', !isOpen);

    if (isOpen) {
      document.addEventListener('click', handleOutsideClick);
      document.addEventListener('keydown', handleEscKey);
    } else {
      document.removeEventListener('click', handleOutsideClick);
      document.removeEventListener('keydown', handleEscKey);
    }
  }

  function handleOutsideClick(e) {
    if (!converter.contains(e.target)) {
      toggleDropdown(false);
    }
  }

  function handleEscKey(e) {
    if (e.key === 'Escape') {
      toggleDropdown(false);
      trigger.focus();
    }
  }

  /**
   * Para birimi seç
   */
  function selectCurrency(currency) {
    if (!currency) return;

    currentCurrency = currency;

    // Cookie'ye kaydet
    Cookie.set(COOKIE_NAME, {
      code: currency.code,
      symbol: currency.symbol,
      rate: currency.rate,
      position: currency.position
    }, COOKIE_DAYS);

    // UI güncelle
    updateUI();

    // Fiyatları dönüştür
    convertAllPrices();

    // Dropdown kapat
    toggleDropdown(false);

    // Custom event
    document.dispatchEvent(new CustomEvent('currency:changed', {
      detail: currency
    }));
  }

  /**
   * UI güncelle
   */
  function updateUI() {
    if (!currentCurrency) return;

    // Current display
    if (currentDisplay) {
      currentDisplay.textContent = currentCurrency.code;
    }

    // Current symbol
    if (currentSymbol) {
      currentSymbol.textContent = currentCurrency.symbol;
    }

    // Active class
    currencies.forEach(c => {
      if (c.element) {
        c.element.classList.toggle('active', c.code === currentCurrency.code);
      }
    });
  }

  /**
   * Fiyat formatla - sayı ve sembol değişir
   */
  function formatPrice(amount, currency) {
    // Sayıyı formatla (2 ondalık)
    const formatted = amount.toFixed(2);

    // Sembol pozisyonuna göre formatla
    if (currency.position === 'after') {
      return `${formatted}${currency.symbol}`;
    }
    return `${currency.symbol}${formatted}`;
  }

  /**
   * Fiyat elementinden sayısal değeri çıkar
   */
  function extractPrice(text) {
    if (!text) return null;

    // Para birimi sembolleri ve formatları temizle
    const cleaned = text
      .replace(/[^\d.,]/g, '')  // Sadece sayı, nokta, virgül
      .replace(/,(\d{2})$/, '.$1')  // Son virgülü noktaya çevir (1.234,56 -> 1.234.56)
      .replace(/,/g, '');  // Diğer virgülleri kaldır (1,234.56 -> 1234.56)

    const num = parseFloat(cleaned);
    return isNaN(num) ? null : num;
  }

  /**
   * Tek bir fiyat elementini dönüştür - sadece değer, format aynı kalır
   */
  function convertPriceElement(el) {
    if (!currentCurrency || currentCurrency.rate === 1) return;

    // Orijinal fiyatı bir kez sakla (internal tracking için)
    if (!el._originalPrice) {
      el._originalPrice = el.textContent.trim();
      el._originalValue = extractPrice(el.textContent);
      el._converted = false;
    }

    // Zaten bu currency'e dönüştürüldüyse atla
    if (el._converted && el._currencyCode === currentCurrency.code) return;

    const originalValue = parseFloat(el._originalValue);
    if (isNaN(originalValue)) return;

    // Dönüştür - sembol ve sayı değişir
    const converted = originalValue * currentCurrency.rate;
    el.textContent = formatPrice(converted, currentCurrency);
    el._converted = true;
    el._currencyCode = currentCurrency.code;
  }

  /**
   * Fiyatı orijinaline döndür
   */
  function resetPriceElement(el) {
    if (el._originalPrice) {
      el.textContent = el._originalPrice;
      el._converted = false;
      el._currencyCode = null;
    }
  }

  /**
   * Tüm fiyatları dönüştür
   */
  function convertAllPrices() {
    // Fiyat elementlerini bul - SADECE bu selector'lar
    const priceSelectors = [
      '.price.price--large.price--show-badge',
      '.glc-money',
      '.price.price--end[data-original-price]'
    ];

    const priceElements = document.querySelectorAll(priceSelectors.join(','));

    // Eğer varsayılan para birimi seçildiyse (rate=1), orijinale döndür
    if (currentCurrency.rate === 1) {
      priceElements.forEach(resetPriceElement);
      return;
    }

    // Dönüştür
    priceElements.forEach(el => {
      // Currency converter'ın kendi elementlerini atla
      if (el.closest('.currency-converter')) return;
      convertPriceElement(el);
    });
  }

  /**
   * MutationObserver ile dinamik içerik için
   */
  function setupObserver() {
    const observer = new MutationObserver((mutations) => {
      let shouldConvert = false;

      mutations.forEach(mutation => {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) { // Element node
              // Currency converter'ı atla
              if (node.classList?.contains('currency-converter')) return;
              if (node.closest?.('.currency-converter')) return;

              // Fiyat içeriyor mu kontrol et - SADECE belirli selector'lar
              if (node.querySelector?.('.price.price--large.price--show-badge, .glc-money, .price.price--end[data-original-price]')) {
                shouldConvert = true;
              }
              if (node.classList?.contains('glc-money') || (node.classList?.contains('price') && node.classList?.contains('price--large'))) {
                shouldConvert = true;
              }
            }
          });
        }
      });

      if (shouldConvert && currentCurrency && currentCurrency.rate !== 1) {
        // Küçük bir gecikme ile dönüştür (DOM'un tamamen yüklenmesi için)
        setTimeout(convertAllPrices, 100);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /**
   * Başlat
   */
  function init() {
    converter = document.getElementById('currency-converter');
    if (!converter) return;

    trigger = document.getElementById('currency-trigger');
    dropdown = document.getElementById('currency-dropdown');
    currentDisplay = document.getElementById('current-currency');
    currentSymbol = document.getElementById('current-symbol');

    if (!trigger || !dropdown) return;

    // Para birimlerini yükle
    loadCurrencies();
    if (currencies.length === 0) return;

    // Kayıtlı para birimini yükle
    currentCurrency = loadSavedCurrency();
    updateUI();

    // İlk dönüşüm
    if (currentCurrency && currentCurrency.rate !== 1) {
      convertAllPrices();
    }

    // Event listeners
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      toggleDropdown();
    });

    // Option click
    currencies.forEach(currency => {
      if (currency.element) {
        currency.element.addEventListener('click', (e) => {
          e.preventDefault();
          selectCurrency(currency);
        });
      }
    });

    // Dinamik içerik için observer
    setupObserver();

    // Sayfa tamamen yüklendiğinde tekrar dönüştür
    window.addEventListener('load', () => {
      if (currentCurrency && currentCurrency.rate !== 1) {
        setTimeout(convertAllPrices, 500);
      }
    });

    console.log('[Currency Converter] Initialized', {
      currencies: currencies.map(c => c.code),
      current: currentCurrency?.code
    });
  }

  // DOM hazır olduğunda başlat
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Global erişim için
  window.CurrencyConverter = {
    convert: convertAllPrices,
    select: (code) => {
      const currency = currencies.find(c => c.code === code);
      if (currency) selectCurrency(currency);
    },
    getCurrent: () => currentCurrency,
    getCurrencies: () => currencies
  };

})();
